import React from 'react';

function TopSong(props) {
    const {topSong} = props
    return (
        <div className='basis-full sm:basis-2/3 flex flex-col'>
            <div className="flex flex-row items-center text-violet-700 font-black text-base md:text-lg mb-4">
                آهنگ های برتر
            </div>
            <div className="grid grid-cols-3 gap-2">
                {
                    topSong.map((song,index) =>
                        <div className='flex flex-row flex-col md:flex-row items-center space-x-3 space-x-reverse'>
                            <img src={song.image} className='w-[60px] h-[60px] sm:w-[80px] sm:h-[80px] rounded mb-1' alt=""/>
                            <div className="flex flex-col justify-around text-gray-800 text-xs">
                                <div className='font-medium mb-1'>{song.name}</div>
                                <div>{song.date}</div>
                            </div>
                        </div>
                    )
                }
            </div>
        </div>
    );
}

export default TopSong;